export default "__VITE_ASSET__BijTz6Ea__"